import {
    closeDropdownsHandler,
    dropdownOptionClickedHandler,
    keyboardNavigationStartedHandler,
    keydownHandler,
    keyupHandler,
    removeMultiSelectChoiceHandler,
    toggleDropdownHandler
} from './Handler';

document.addEventListener('keyup', keyupHandler);
document.addEventListener('keydown', keydownHandler);

document.addEventListener('closedropdowns', closeDropdownsHandler);
document.addEventListener('toggledropdown', toggleDropdownHandler);
document.addEventListener('removemultiselectchoice', removeMultiSelectChoiceHandler);
document.addEventListener('dropdownoptionclicked', dropdownOptionClickedHandler);
document.addEventListener('keyboardnavigationstarted', keyboardNavigationStartedHandler);
